import useModal from "@/@core/components/base-modal/hooks/useModal";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import router from "@/router";
import store from "@/store";
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable";
import usePagination from "@/views/components/pagination/usePagination";
import {
  onBeforeMount,
  reactive,
  ref,
  watch,
  getCurrentInstance,
} from "@vue/composition-api";
import { privilegeImageList } from "@/@fake-db/mock-code-template/select-privilege-image-list";

import { privilegeCodeTemplateModel } from "@/models/privilege/privilege-code-template";

export default function useChoosePrivilege(props) {
  const vm = getCurrentInstance().proxy;
  const { getPrivilegeImageList } = privilegeCodeTemplateModel();

  const { pagination, onPageChange, onFilterEntity } = usePagination();
  const {
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
  } = useFilterHeaderTable();
  const { openDefaultErrorModal, openErrorModal } = useValidationModal();

  const loading = reactive({
    tableData: false,
    tableOverlay: false,
  });

  const selectImageList = reactive({
    payload: [],
  });

  const fields = [
    { key: "image_url", label: "Image" },
    { key: "image_name", label: "Image Name" },
    { key: "actions", label: "" },
  ];

  const fetchPrivilegeImageList = () => {
    loading.tableData = true;
    getPrivilegeImageList.payload.Page = pagination.currentPage;
    getPrivilegeImageList.payload.Limit = pagination.perPage;
    getPrivilegeImageList.payload.Filters = filters;
    getPrivilegeImageList.payload.Ordering = ordering.value;
    getPrivilegeImageList.payload.Privilege_Id = props.privilegeId;

    store
      .dispatch("api/apiRequest", getPrivilegeImageList)
      .then((response) => {
        selectImageList.payload = response.data.payload;
        pagination.rows = response.data.payload.length;
        pagination.totalRows = response.data.filtered_record;
        
        if (props.privilegeId){
          selectImageList.payload.map(o => {
            if(o.image_id == props.imageId)
              selectPrivilegeImage(o)
          })
        }
        
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.tableData = false;
      });
  };

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchPrivilegeImageList();
      }
    },
    { deep: true }
  );

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1;

      fetchPrivilegeImageList();
    },
    { deep: true }
  );

  const image_Id = ref(null);
  const privilegeImgObj = reactive({
    data: {},
  });

  const selectPrivilegeImage = (obj) => {
    image_Id.value = obj.image_id;
    privilegeImgObj.data = obj;
  };

  const onSaveModalSelectImage = () => {
    vm.$emit("onSaveImage", privilegeImgObj.data);
    vm.$emit("onCloseModal");
  };

  onBeforeMount(() => {
    if (props.privilegeId) image_Id.value = props.imageId;
    fetchPrivilegeImageList();
  });

  return {
    loading,
    fields,
    selectImageList,

    pagination,
    onPageChange,
    onFilterEntity,
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,

    onSaveModalSelectImage,
    selectPrivilegeImage,
    image_Id,
  };
}
